import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=0ffc3436&"
import script from "./RawData.vue?vue&type=script&lang=js&"
export * from "./RawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports